import { getAssignmentPathForLead } from "utils/assignmentPathForLead";
import { getFollowUpPathForLead } from "utils/followUpPathForLead";
import { getLegalCertificatePathForLead } from "utils/legalCertificatePathForLead";
import { getNewApplicationPathForLead } from "utils/newApplicationPathForLead";
import { getOppositionPathForLead } from "utils/oppositionPathForLead";
import { getRenewalPathForLead } from "utils/renewalPathForLead";
import { getSurveillancePathForLead } from "utils/surveillancePathForLead";

const NEW_APP_DEFAULT_PATH = (leadId: string): string =>
  `/dashboard/applications/new-application/discussion/preliminary-discussion-with-the-client/${leadId}`;

/**
 * Resolve the in-app path for a lead given its module. Delegates to the per-module resolver
 * which inspects the lead's workflow progress and routes to the lead's most recently
 * completed step. Falls back to the module's preliminary discussion step when progress
 * lookup fails or no step has been completed yet.
 */
export async function getPathForLeadByModule(
  module: string | null | undefined,
  leadId: string
): Promise<string> {
  const key = (module ?? "").trim().toUpperCase();
  switch (key) {
    case "NEW_APP":
      return getNewApplicationPathForLead(leadId);
    case "FOLLOW_UP":
      return getFollowUpPathForLead(leadId);
    case "OPPOSITION":
      return getOppositionPathForLead(leadId);
    case "ASSIGNMENT":
      return getAssignmentPathForLead(leadId);
    case "RENEWAL":
      return getRenewalPathForLead(leadId);
    case "LEGAL_CERTIFICATE":
      return getLegalCertificatePathForLead(leadId);
    case "SURVEILLANCE":
      return getSurveillancePathForLead(leadId);
    default:
      return NEW_APP_DEFAULT_PATH(leadId);
  }
}
